<template>
  <bk-page 
		pageType="navPage" 
		:navBarInfo="navBarInfo"
        class="view-checkInForm"
	>

        <bk-view class="view-form">
          <bk-view class="view-input">
            <bk-first-last 
				mustFlag
				v-model:firstName="formData.firstName"
				v-model:lastName="formData.lastName"
			/>
          </bk-view>

          <bk-view class="view-input">
            <bk-view class="view-label"><span style="color: #f53f3f;vertical-align: middle;margin-right: 4px;font-size:12px">*</span><bk-lang code="checkInForm_phone"></bk-lang> </bk-view>
           <phoneInput
				:dataList="dictInfo.intMobileCd"
				v-model="formData.mobile"
				v-model:intMobileCd="formData.mobileCdValue"
				v-model:intMobileCode="formData.mobileCdCode"
			/>
          </bk-view>

          <bk-view class="view-input">
            <bk-view class="view-label"><bk-lang code="checkInForm_email"></bk-lang> </bk-view>
            <bk-input
              size="full"
              autoSelect
              v-model:value="formData.email"
              langCode_placeholder="signup_text_emailAddress">
            </bk-input>
          </bk-view>

          <bk-view class="view-input">
            <bk-datePicker v-model:value="formData.birthday" langCode_label="signup_text_birthday" />
          </bk-view>

          <bk-view class="view-input">
            <bk-view class="view-label"><bk-lang code="checkInForm_note"></bk-lang> </bk-view>
            <a-textarea class="view-textarea" v-model:value="formData.remark" :rows="5" />
          </bk-view>

        </bk-view>

        <bk-view class="view-btn">
            <bk-button langCode="checkInForm_Save" @click="saveClick"></bk-button>
        </bk-view>
    <transition name="rightFadeIn">
        <signInSuccess v-if="showPage == 'signInSuccess'" :info="{rewardsNum: 5}" @close="showPage=''"></signInSuccess>       
    </transition>
  </bk-page>
</template>

<script>

	import {customerReq, baseReq, shopReq} from '@/reqService/index';
	import PhoneInput from '@/pages/login/signup/phoneInput/phoneInput.vue';
    import bkFirstLast from '@/components/bk-business/bk-first-last/bk-first-last.vue';
    import signInSuccess from '../signInSuccess/signInSuccess.vue'

	export default {
		name: 'signup',
		components: {
			PhoneInput,
            bkFirstLast,
            signInSuccess,
		},
        props : {
            curShop: Object,
            type: Number,
			tempValue: String,
        },
		data () {
			return {
                loading: false,
				navBarInfo: {
					backFlag: true,
					langCode_title: 'checkInForm_title',
					titleAlign: 'left',
				},
				bkLoad: false,
                dictInfo:{},
                formData: {
                    email: '',
                    firstName: '',
                    lastName: '',
                    mobile: '',
                    mobileCdCode: '',
                    mobileCdValue: '',
                    remark: '',
                    birthday: '',
                },
                showPage: '',
				
			};
		},
        computed:{
           
        },
        
		methods: {
            async saveClick (){
				
				

				const params = this.getSubmitParmas();
                let {firstName, lastName, mobile} = params.member
                if (!firstName && !lastName) {
                    this.$bk_message.error({ langCode:'checkInForm_verify_name'});
					return 
                }
                if (!mobile) {
                    this.$bk_message.error({ langCode:'checkInForm_verify_mobile'});
					return 
                }
				this.loading = true; 

                this.$bk_saveDevelopLog({
                    keyword: `新客户签到提交`,
                    actionData: {curShop: this.curShop,params}
                });


				customerReq.memberCheckIn(this, params).then((res) => {

					this.loading = false;
					this.$emit('close');
					if (res) {
						this.$emit('getCheckIn',res)
					}
				}).catch(() => {
					this.loading = false;
				});
			},
            // 处理提交数据
			getSubmitParmas (){
				const params = {
					custId: this.curShop.custId,
					compId: this.curShop.id || this.curShop.compId,
					member: this.formData,
                    remark: this.formData.remark
				};

				params.member.email =  String(params.member.email).trim();
				return params;
			},
           
		},
		async created () {
            
		},
		async mounted () {
            this.dictInfo = await baseReq.requestPostDictByTypeCode(this, ['intMobileCd'] || this.$bk_Global.dictList);
            
			let shopId = localStorage.getItem('ShopDetailId');
            this.$bk_saveDevelopLog({
				keyword: `新客户签到页`,
                actionData: {curShop: this.curShop,shopId,tempValue: this.tempValue}
			});
			if (this.curShop&&this.curShop.id&&this.curShop.countryCode) {
			// if ((shopId && shopId != '') || (this.curShop&&this.curShop.id)) {
				// let res = await shopReq.requestGetShopDetailByCompId(this, shopId || this.curShop.id);

				// if (!res) {
				// 	return;
				// }

				// bkLog.log('查询到的门店：', res);
				// const { countryCode } = res || {};
                bkLog.log('查询到的门店：', this.curShop);
				const { countryCode } = this.curShop || {};
        
				this.formData.mobileCdCode = countryCode?.toUpperCase() || 'US';
				let defItem = this.$bk_findObjInList(this.dictInfo.intMobileCd, 'code', this.formData.mobileCdCode);

				bkLog.log('defItem::', defItem,this.formData);

				if (defItem) {
					this.formData.mobileCdValue = defItem.value;
				} else {
					this.formData.mobileCdValue = '+1';
				}
			}
            this.$nextTick(() => {
                if (this.type == 1) {
					this.formData.mobile = this.tempValue
				} else {
					this.formData.email = this.tempValue
				}
            })
		}
	};
</script>

<style lang="less" scoped>
.view-checkInForm {
    padding: 80px 24px 0;
    .view-form {
        > .view-input {
            margin-bottom: 24px;
            > .view-label {
                vertical-align: top;
                line-height: 18px;
                padding-bottom: 4px;
                font-size: 12px;
                color: #666;
            }
            > :deep(.view-textarea) {
                border:  1px solid #eaeaf5;
                &:focus {
                    box-shadow: none;
                }
            }
        }
    }
    .view-btn {
        position: fixed;
        bottom: 0;
        left: 0;
        height: 76px;
        line-height: 56px;
        text-align: right;
        border-top: 1px solid #E0E7FE;
        width: 100%;
        > .bk-button {
            height: 32px;
            background: #2E56F2;
            border: 1px solid #2E56F2;
            margin-right: 16px;
        }
        
    }
}

</style>